import {
  DEFAULT_MARKDOWN_PLACEHOLDER,
  DEFAULT_COLOR_PRIMARY,
} from '../constants'
import { basePropertiesSchema } from '../base-schema-properties'
import {
  buttonsPropertiesSchema,
  shadowSchema,
  textFontFamilySchema,
} from '../common'

const responsiveProperties = (
  prefix: 'mobile' | 'medium',
  viewName: string,
  toggleTitle: string
) => {
  const enabledProperty = `override${
    prefix.charAt(0).toUpperCase() + prefix.slice(1)
  }View`
  const hidden = `{{ parentFormData.${enabledProperty} !== true }}`
  const bgImageProperty = `${prefix}BgImage`

  return {
    [enabledProperty]: {
      title: toggleTitle,
      type: 'boolean',
      default: false,
    },
    [`${prefix}BgImage`]: {
      title: `Background image — ${viewName}`,
      description: 'Leave empty to use the desktop background.',
      type: 'string',
      'ui:hidden': hidden,
    },
    [`${prefix}BgColor`]: {
      title: `Background color — ${viewName}`,
      description:
        'Choose a color to replace the desktop background image for this view.',
      type: 'string',
      'ui:hidden': `{{ parentFormData.${enabledProperty} !== true || !!parentFormData.${bgImageProperty} }}`,
    },
    [`${prefix}TextAlign`]: {
      title: `Text Align — ${viewName}`,
      description: 'Uses the desktop alignment until changed.',
      enum: ['left', 'center', 'right'],
      enumNames: ['Left', 'Center', 'Right'],
      'ui:widget': 'RadioWidget',
      'ui:hidden': hidden,
    },
  }
}

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Banners',
  description: 'Banners with background, text and buttons',
  type: 'object',
  required: [],
  properties: {
    ...basePropertiesSchema,
    ...shadowSchema,
    banners: {
      type: 'array',
      title: 'A list of banners',
      'ui:options': {
        showIndexNumber: true,
      },
      items: {
        title: 'Banner',
        type: 'object',
        properties: {
          text: {
            title: 'Text',
            type: 'string',
            'ui:options': {
              placeholder: DEFAULT_MARKDOWN_PLACEHOLDER,
              type: 'textarea',
              rows: 6,
            },
          },
          textColor: {
            title: 'Text Color',
            type: 'string',
            default: '#ffffff',
          },
          ...textFontFamilySchema,
          linkColor: {
            title: 'Link Color',
            type: 'string',
            default: DEFAULT_COLOR_PRIMARY,
          },
          textAlign: {
            title: 'Text Align',
            enum: ['left', 'center', 'right'],
            enumNames: ['Left', 'Center', 'Right'],
            default: 'center',
            'ui:widget': 'RadioWidget',
          },
          isBgImage: {
            title: 'Use image for background',
            type: 'boolean',
            default: true,
          },
          bgImage: {
            title: 'Background image',
            type: 'string',
            default: 'https://cdn.wnhub.io/39253/65dde526e1a6c4.93735968.jpg',
            'ui:hidden': '{{ parentFormData.isBgImage === false }}',
          },
          bgColor: {
            title: 'Background color',
            type: 'string',
            'ui:hidden': '{{ parentFormData.isBgImage === true }}',
          },
          paddingSize: {
            title: 'Paddings',
            enum: ['xs', 'sm', 'md', 'lg'],
            enumNames: ['Extra small', 'Small', 'Medium', 'Large'],
            default: 'md',
            'ui:widget': 'RadioWidget',
          },
          ...responsiveProperties('mobile', 'mobile', 'Override mobile view'),
          ...responsiveProperties(
            'medium',
            'tablets and small laptops',
            'Override tablet and small laptop view'
          ),
          ...buttonsPropertiesSchema,
        },
      },
    },
  },
}
